import { getURIParams, Log } from '@utils';

import { Api } from '../Api';
import { ApiError } from '../utils/ApiError';

import { IApiBaseRequestParams, IApiBaseResponseData, IApiRequest, IApiResponse } from '@interfaces';

interface IHttpTransportOptions {
	arrayFormat?: 'enumeration' | 'comma';
}

// eslint-disable-next-line import/no-unused-modules
export class BaseApi {

	protected api: typeof Api;

	constructor(api: typeof Api) {
		this.api = api;
	}

	async http<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>, options?: IHttpTransportOptions): Promise<IApiResponse<P>> {
		const opts = {
			arrayFormat: 'comma',
			...options,
		};
		const transport = this.api.getTransport();
		// const isAbsoluteUrl = /^https?/.test(params.url);
		const data = params.data && !params.isNoProcessData ? getURIParams(params.data, { arrayFormat: opts.arrayFormat }) : params.data || null;

		// params.url = isAbsoluteUrl ? params.url : `/v1${params.url}`;

		try {
			return await transport.http({
				...params,
				data,
			});
		} catch (err) {
			const error = new ApiError({
				...err,
				request: {
					url: params.url,
					method: params.method,
					data,
				},
			});

			Log.errorRequest(error);

			throw error;
		}
	}

	async get<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>, options?: IHttpTransportOptions): Promise<IApiResponse<P>> {
		params.method = 'GET';

		return this.http(params, options);
	}

	async post<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>, options?: IHttpTransportOptions): Promise<IApiResponse<P>> {
		params.method = 'POST';

		return this.http(params, options);
	}

	async put<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>, options?: IHttpTransportOptions): Promise<IApiResponse<P>> {
		params.method = 'PUT';

		return this.http(params, options);
	}

	async delete<T extends IApiBaseRequestParams, P extends IApiBaseResponseData>(params: IApiRequest<T>, options?: IHttpTransportOptions): Promise<IApiResponse<P>> {
		params.method = 'DELETE';
		params.headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
		};

		return this.http(params, options);
	}

}
